import Layout from "@/components/PageLayout/index";
import PrivateRoute from "./privateRouter";
import { routeConfig } from "./route";
import { Suspense, lazy } from "react";
import { CIDToolCenterRouterMap, ToolCenterRouterMap, useToolCenterRoutes, useCIDToolCenterRoutes } from "@BZA/ToolCenter/router";
import { AIDRoutercampaignRouterMap, useAIDRouterConfig as useImportedAIDRouterConfig } from "./AIDRouter";
import { BaseRouter, msnUniversalRouters, UniversalRouters, useUniversalRouters, useMSNUniversalRouters, useCrossBorderUniversalRouters } from "./universalRouters";
import { HelpCenterRouterMap, useHelpCenterRouterMap } from "@BZA/HelpCenter/router";
import { SettlementCIDRouter, useSettlementCIDRouterConfig } from "./SettlementCIDRouter";
import { QualificationPages } from "@/features/BZA/Qualification/router";
import { msnCampaignRouterMap, useMSNCampaignRouterConfig } from "@/features/LeadGen/CampaignManagement/router";
import { MSNbillingRouter } from "@/features/LeadGen/BillingSummary/router";
import { MSNAdmainCIDRouter, MSNAIDRouter, MSNCIDRouter } from "./MSNRouterMap";
import { LeadGneQualificationPages, useQualificationRoutes } from "@/features/LeadGen/Qualification/router";
import { CrossBorderAIDRouter, CrossBorderAIDRouterPages, CrossBorderCIDRouter, CrossBorderCIDRouterPages, useCrossBorderAIDRouterConfig, useCrossBorderAIDRouterPages, useCrossBorderCIDRouterConfig, useCrossBorderCIDRouterPages } from "./CrossBorderRputerMap";
import { useTranslation } from "react-i18next";

export const LazyLoad = (path: string) => {
  const Comp = lazy(() => import("@BZA/" + path));
  return (
    <Suspense fallback={<></>}>
      <Comp />
    </Suspense>
  );
};

// 生成路由配置的函数
export const useRouterConfig = () => {
  const { t } = useTranslation();
  const aidRoutes = useImportedAIDRouterConfig();
  const universalRouters = useUniversalRouters();
  const msnUniversalRouters = useMSNUniversalRouters();
  const crossBorderAIDRouterPages = useCrossBorderAIDRouterPages();
  const crossBorderCIDRouterPages = useCrossBorderCIDRouterPages();
  const msnCampaignRoutes = useMSNCampaignRouterConfig();
  const qualificationRoutes = useQualificationRoutes();
  const toolCenterRoutes = useToolCenterRoutes();
  const helpCenterRoutes = useHelpCenterRouterMap();

  return [
    {
      path: "/",
      element: (
        <PrivateRoute>
          <Layout />
        </PrivateRoute>
      ),
      name: "",
      children: [
        {
          path: "/dashboard",
          element: LazyLoad("Account/Dashboard"),
          name: t("Basics.LeftMenu.Dashboard"),
          key: "homeKey",
          icon: "Home",
        },
        ...aidRoutes,
        {
          path: "/report",
          element: LazyLoad("Reoprt/index"),
          name: t("Basics.LeftMenu.ReportStatistics"),
          key: "tableKey",
          icon: "Table",
          children: [
            {
              path: "effectReport",
              name: t("Basics.LeftMenu.EffectiveReport"),
              key: "effectReportKey",
              element: LazyLoad("Reoprt/effectReport"),
            },
            // {
            //   path: "monthlyReport",
            //   name: "月度报表",
            //   key: "monthlyReportKey",
            //   element: LazyLoad("Reoprt/monthlyReport"),
            // }
          ]
        },
        ...toolCenterRoutes,
        ...universalRouters,
        ...helpCenterRoutes,
        ...SettlementCIDRouter,
        // test
        ...QualificationPages,
        ...msnUniversalRouters,
        ...msnCampaignRoutes,
        ...BaseRouter,
        ...MSNbillingRouter,
        ...qualificationRoutes,
        ...crossBorderAIDRouterPages,
        ...crossBorderCIDRouterPages
      ],
    }
  ];
};

export const routerMap: routeConfig[] = [
  {
    path: "/",
    element: (
      <PrivateRoute>
        <Layout />
      </PrivateRoute>
    ),
    name: "",
    children: [
      {
        path: "/dashboard",
        element: LazyLoad("Account/Dashboard"),
        name: "首页",
        key: "homeKey",
        icon: "Home",
      },
      ...AIDRoutercampaignRouterMap,
      {
        path: "/report",
        element: LazyLoad("Reoprt/index"),
        name: "报表统计",
        key: "tableKey",
        icon: "Table",
        children: [
          {
            path: "effectReport",
            name: "效果报告",
            key: "effectReportKey",
            element: LazyLoad("Reoprt/effectReport"),
          },
          // {
          //   path: "monthlyReport",
          //   name: "月度报表",
          //   key: "monthlyReportKey",
          //   element: LazyLoad("Reoprt/monthlyReport"),
          // }
        ]
      },
      ...ToolCenterRouterMap,
      ...UniversalRouters,
      ...HelpCenterRouterMap,
      ...SettlementCIDRouter,
      // test
      ...QualificationPages,
      ...msnUniversalRouters,
      ...msnCampaignRouterMap,
      ...BaseRouter,
      ...MSNbillingRouter,
      ...LeadGneQualificationPages,
      ...CrossBorderAIDRouterPages,
      ...CrossBorderCIDRouterPages
    ],
  }
];

export const useAIDRouterConfig = () => {
  const { t } = useTranslation();
  const ToolCenterRouterMap = useToolCenterRoutes();
  const UniversalRouters = useUniversalRouters();
  const HelpCenterRouterMap = useHelpCenterRouterMap();
  const AIDRoutercampaignRouterMap = useImportedAIDRouterConfig();

  return [
    {
      path: "/",
      element: (
        <PrivateRoute>
          <Layout />
        </PrivateRoute>
      ),
      name: "",
      children: [
        {
          path: "/dashboard",
          element: LazyLoad("Account/Dashboard"),
          name: t("Basics.LeftMenu.Dashboard"),
          key: "homeKey",
          icon: "Home",
        },
        ...AIDRoutercampaignRouterMap,
        {
          path: "/report",
          element: LazyLoad("Reoprt/index"),
          name: t("Basics.LeftMenu.ReportStatistics"),
          key: "tableKey",
          icon: "Table",
          children: [
            {
              path: "effectReport",
              name: t("Basics.LeftMenu.EffectiveReport"),
              key: "effectReportKey",
              element: LazyLoad("Reoprt/effectReport"),
            },
            // {
            //   path: "monthlyReport",
            //   name: "月度报表",
            //   key: "monthlyReportKey",
            //   element: LazyLoad("Reoprt/monthlyReport"),
            // }
          ]
        },
        ...ToolCenterRouterMap,
        ...UniversalRouters,
        ...HelpCenterRouterMap
      ],
    }
  ];
};

export const AIDrouterMap: routeConfig[] = [
  {
    path: "/",
    element: (
      <PrivateRoute>
        <Layout />
      </PrivateRoute>
    ),
    name: "",
    children: [
      {
        path: "/dashboard",
        element: LazyLoad("Account/Dashboard"),
        name: "首页",
        key: "homeKey",
        icon: "Home",
      },
      ...AIDRoutercampaignRouterMap,
      {
        path: "/report",
        element: LazyLoad("Reoprt/index"),
        name: "报表统计",
        key: "tableKey",
        icon: "Table",
        children: [
          {
            path: "effectReport",
            name: "效果报告",
            key: "effectReportKey",
            element: LazyLoad("Reoprt/effectReport"),
          },
          // {
          //   path: "monthlyReport",
          //   name: "月度报表",
          //   key: "monthlyReportKey",
          //   element: LazyLoad("Reoprt/monthlyReport"),
          // }
        ]
      },
      ...ToolCenterRouterMap,
      ...UniversalRouters,
      ...HelpCenterRouterMap
    ],
  }
];

export const useCIDRouterConfig = () => {
  const { t } = useTranslation();
  const CIDToolCenterRouterMap = useCIDToolCenterRoutes();
  const UniversalRouters = useUniversalRouters();
  const HelpCenterRouterMap = useHelpCenterRouterMap();
  return [
    {
      path: "/",
      element: (
        <PrivateRoute>
          <Layout />
        </PrivateRoute>
      ),
      name: "",
      children: [
        {
          path: "/dashboard",
          element: LazyLoad("Account/Dashboard"),
          name: t("Basics.LeftMenu.Dashboard"),
          key: "homeKey",
          icon: "Home",
        },
        {
          path: "/report",
          element: LazyLoad("Reoprt/index"),
          name: t("Basics.LeftMenu.ReportStatistics"),
          key: "tableKey",
          icon: "Table",
          children: [
            {
              path: "effectReport",
              name: t("Basics.LeftMenu.EffectiveReport"),
              key: "effectReportKey",
              element: LazyLoad("Reoprt/effectReport"),
            },
            // {
            //   path: "monthlyReport",
            //   name: "月度报表",
            //   key: "monthlyReportKey",
            //   element: LazyLoad("Reoprt/monthlyReport"),
            // }
          ]
        },
        ...CIDToolCenterRouterMap,
        ...UniversalRouters,
        ...HelpCenterRouterMap,
      ],
    }
  ];
};

export const CIDrouterMap: routeConfig[] = [
  {
    path: "/",
    element: (
      <PrivateRoute>
        <Layout />
      </PrivateRoute>
    ),
    name: "",
    children: [
      {
        path: "/dashboard",
        element: LazyLoad("Account/Dashboard"),
        name: "首页",
        key: "homeKey",
        icon: "Home",
      },
      {
        path: "/report",
        element: LazyLoad("Reoprt/index"),
        name: "报表统计",
        key: "tableKey",
        icon: "Table",
        children: [
          {
            path: "effectReport",
            name: "效果报告",
            key: "effectReportKey",
            element: LazyLoad("Reoprt/effectReport"),
          },
          // {
          //   path: "monthlyReport",
          //   name: "月度报表",
          //   key: "monthlyReportKey",
          //   element: LazyLoad("Reoprt/monthlyReport"),
          // }
        ]
      },
      ...CIDToolCenterRouterMap,
      ...UniversalRouters,
      ...HelpCenterRouterMap,
    ],
  }
];

export const baseRouterMap: routeConfig[] = [
  // { path: "/login", name: "login", element: <Navigate to="/" />, },
  {
    path: "/",
    element: LazyLoad("Account/Login/index"),
    name: "login",
    isHidden: true
  },
  {
    path: "/invitation",
    element: LazyLoad("Account/Registration/invitation"),
    name: "invitation",
    key: "InvitationKey",
    isHidden: true
  },
  {
    path: "/empty",
    element: LazyLoad("empty"),
    name: "empty",
    isHidden: true
  },
];

export const SettlementManagementCIDrouterMap: routeConfig[] = [
  {
    path: "/",
    element: (
      <PrivateRoute>
        <Layout />
      </PrivateRoute>
    ),
    name: "",
    children: [
      ...SettlementCIDRouter,
      ...UniversalRouters
    ],
  }
];

export const SettlementManagementAIDrouterMap: routeConfig[] = [
  {
    path: "/",
    element: (
      <PrivateRoute>
        <Layout />
      </PrivateRoute>
    ),
    name: "",
    children: [
      ...UniversalRouters,
      ...HelpCenterRouterMap
    ],
  }
];
export const MSNCIDRouterMap: routeConfig[] = [
  ...MSNCIDRouter
];

export const MSNAdmainCIDRouterMap: routeConfig[] = [
  ...MSNAdmainCIDRouter
];

export const MSNAIDRouterMap: routeConfig[] = [
  ...MSNAIDRouter
];

export const CrossBorderCIDRouterMap: routeConfig[] = [
  ...CrossBorderCIDRouter
];

export const CrossBorderAIDRouterMap: routeConfig[] = [
  ...CrossBorderAIDRouter
];
export const useCrossBorderCIDRouterMapConfig = () => {
  const CrossBorderCIDRouter = useCrossBorderCIDRouterConfig();
  return [
    ...CrossBorderCIDRouter
  ];
};

export const useCrossBorderAIDRouterMapConfig = () => {
  const CrossBorderAIDRouter = useCrossBorderAIDRouterConfig();
  return [
    ...CrossBorderAIDRouter
  ];
};

export const useSettlementManagementCIDRouterMapConfig = () => {
  const SettlementCIDRouter = useSettlementCIDRouterConfig();
  const UniversalRouters = useUniversalRouters();
  return [
    {
      path: "/",
      element: (
        <PrivateRoute>
          <Layout />
        </PrivateRoute>
      ),
      name: "",
      children: [
        ...SettlementCIDRouter,
        ...UniversalRouters
      ],
    }
  ];
};

export const useSettlementManagementAIDRouterMapConfig = () => {
  const UniversalRouters = useUniversalRouters();
  const HelpCenterRouterMap = useHelpCenterRouterMap();
  return [
    {
      path: "/",
      element: (
        <PrivateRoute>
          <Layout />
        </PrivateRoute>
      ),
      name: "",
      children: [
        ...UniversalRouters,
        ...HelpCenterRouterMap
      ],
    }
  ];
};
